import { areParamsEqual } from "../../utils/globalUtilities";
import { ResearchListSortOrder, SortByOption, SortConst, SortListOrder, TabMapping } from "../../features/searchpage/constants/filters.constants";
import { useEffect, useState } from "react";
import SortListShimmer from "./SortListShimmer";

const Sortist = ({ selectedTab, selectSortOption, selectSortOrder, onClickSortOption, onClickSortOrder }: any) => {
  const [sortOptions, setSortOptions] = useState([]);
  const [selectedSortOption, setSelectedSortOption] = useState(selectSortOption);
  const [selectedSortOrder, setSelectedSortOrder] = useState(selectSortOrder);


  useEffect(() => {
    if (selectedTab?.id) {
      getSortOptions(selectedTab?.id)
    } else {
      getSortOptions(['search'])
    }
  }, [selectedTab]);

  useEffect(() => {
    if (selectSortOption?.value) {
      setSelectedSortOption(selectSortOption)
    }
  }, [selectSortOption]);


  useEffect(() => {
    if (selectSortOrder?.value) {
      setSelectedSortOrder(selectSortOrder.value)
    }
  }, [selectSortOrder]);
  const isTab = (tabIds:any, targetTabIds:any) => {
    const tabIdsArray = Array.isArray(tabIds) ? tabIds : [tabIds];
    const targetArray = Array.isArray(targetTabIds) ? targetTabIds : [targetTabIds];
    
    // Check if any of the tabIds match any of the targetTabIds
    const directMatch = tabIdsArray.some(id => targetArray.includes(id));
    
    // Check if selectedTab.id includes any of the targetTabIds
    const selectedTabMatch = Array.isArray(selectedTab?.id) && 
                             selectedTab?.id.some((id:any) => targetArray.includes(id));
    
    // Check if selectedTab.name matches specific conditions for certain tabs
    const nameMatch = (targetTabIds === TabMapping.OTHERS && selectedTab?.name === "Others") ||
                      (targetTabIds === TabMapping.ACTRULES && selectedTab?.name === "Acts & Rules");
    
    return directMatch || selectedTabMatch || nameMatch;
  };

  const isSearchTab = (tabIds:any) => isTab(tabIds, TabMapping.SEARCH) || tabIds === 'All' || selectedTab?.name === 'All';
  const isCaseLawsTab = (tabIds:any) => isTab(tabIds, TabMapping.CASELAWS);
  const isActRulesTab = (tabIds:any) => isTab(tabIds, TabMapping.ACTRULES);
  const isFormsTab = (tabIds:any) => isTab(tabIds, TabMapping.FORMS);
  const isReadTab = (tabIds:any) => isTab(tabIds, TabMapping.READ);
  const isVideoTab = (tabIds:any) => isTab(tabIds, TabMapping.VIDEO);
  const isCircularsNotificationsTab = (tabIds:any) => isTab(tabIds, TabMapping.CIRNOTTIF);
  const isArticlesCommentariesTab = (tabIds:any) => isTab(tabIds, TabMapping.ARTCOMM);
  const isLatestTab:any = () => selectedTab?.name === "Latest";
  const isTariffTab = (tabIds:any) => isTab(tabIds, TabMapping.TARIFF);
  const isOthersTab:any = () => selectedTab?.name === "Others";
  
  const getSortOptions = (tabIds: any) => {
    const allSortOptions = SortByOption;
    let filteredOptions:any = [];
    
    if (isOthersTab(tabIds)) {
      const relevanceOption = allSortOptions.find((option:any) => option.value === SortConst.RELEVANCE_WISE);
      const dateOption = allSortOptions.find((option:any) => option.value === SortConst.DATE_WISE);
      
      if (relevanceOption) filteredOptions.push(relevanceOption);
      if (dateOption) filteredOptions.push(dateOption);
      
      setSortOptions(filteredOptions);
      return;
    }
    
    if (isSearchTab(tabIds)) {
      const relevanceOption = allSortOptions.find((option:any) => option.value === SortConst.RELEVANCE_WISE);
      const dateOption = allSortOptions.find((option:any) => option.value === SortConst.DATE_WISE);
      
      if (relevanceOption) filteredOptions.push(relevanceOption);
      if (dateOption) filteredOptions.push(dateOption);
      
      setSortOptions(filteredOptions);
      return;
    }

    const relevanceOption = allSortOptions.find((option:any) => option.value === SortConst.RELEVANCE_WISE);
    if (relevanceOption) filteredOptions.push(relevanceOption);
    
    if (isCaseLawsTab(tabIds)) {
      const nameOption = allSortOptions.find((option:any) => option.value === SortConst.NAME_WISE);
      const dateOption = allSortOptions.find((option:any) => option.value === SortConst.DATE_WISE);
      const courtOption = allSortOptions.find((option:any) => option.value === SortConst.COURT_WISE);
      const citationOption = allSortOptions.find((option:any) => option.value === SortConst.CITIATON_WISE);
      
      if (nameOption) filteredOptions.push(nameOption);
      if (dateOption) filteredOptions.push(dateOption);
      if (courtOption) filteredOptions.push(courtOption);
      if (citationOption) filteredOptions.push(citationOption);
    }
    else if (isActRulesTab(tabIds)) {
      const alphaNumericOption = allSortOptions.find((option:any) => option.value === SortConst.ALPHA_NUMERIC_WISE);
      if (alphaNumericOption) filteredOptions.push(alphaNumericOption);
    }
    else if (isFormsTab(tabIds)) {
      const alphaNumericOption = allSortOptions.find((option:any) => option.value === SortConst.ALPHA_NUMERIC_WISE);
      if (alphaNumericOption) filteredOptions.push(alphaNumericOption);
    }
    else if (isReadTab(tabIds)) {
    }
    else if (isCircularsNotificationsTab(tabIds)) {
      const dateOption = allSortOptions.find((option:any) => option.value === SortConst.DATE_WISE);
      const alphaNumericOption = allSortOptions.find((option:any) => option.value === SortConst.ALPHA_NUMERIC_WISE);
      
      if (dateOption) filteredOptions.push(dateOption);
      if (alphaNumericOption) filteredOptions.push(alphaNumericOption);
    }
    else if (isVideoTab(tabIds)) {
      const dateOption = allSortOptions.find((option:any) => option.value === SortConst.DATE_WISE);
      if (dateOption) filteredOptions.push(dateOption);
    }
    else if (isArticlesCommentariesTab(tabIds)) {
      const dateOption = allSortOptions.find((option:any) => option.value === SortConst.DATE_WISE);
      const alphaNumericOption = allSortOptions.find((option:any) => option.value === SortConst.ALPHA_NUMERIC_WISE);
      
      if (dateOption) filteredOptions.push(dateOption);
      if (alphaNumericOption) filteredOptions.push(alphaNumericOption);
    }
    else if (isLatestTab(tabIds)) {
      const dateOption = allSortOptions.find((option:any) => option.value === SortConst.DATE_WISE);
      const alphaNumericOption = allSortOptions.find((option:any) => option.value === SortConst.ALPHA_NUMERIC_WISE);
      
      if (dateOption) filteredOptions.push(dateOption);
      if (alphaNumericOption) filteredOptions.push(alphaNumericOption);
    }
    else if (isTariffTab(tabIds)) {
      const alphaNumericOption = allSortOptions.find((option:any) => option.value === SortConst.ALPHA_NUMERIC_WISE);
      const chapterOption = allSortOptions.find((option:any) => option.value === SortConst.CHAPTER_CWISE);
      
      if (alphaNumericOption) filteredOptions.push(alphaNumericOption);
      if (chapterOption) filteredOptions.push(chapterOption);
    }
    else {
      setSortOptions(filteredOptions);
    }
    
    setSortOptions(filteredOptions);
  };


  const onChangeSortOrder = (sortOrder: number) => {
    let order = sortOrder == 1 ? 0 : 1;
    onClickSortOrder(order)
  }
  const isRelevanceSelected = selectedSortOption?.value === SortConst?.RELEVANCE_WISE;

  return (
    <>
      {
        selectedSortOption?.label ?
          <li className="sort-option-list">

            {
              !isRelevanceSelected && SortListOrder.map((option: any, index: number) =>
                selectSortOrder == option.value ?
                  <span key={`SortList${index}`} className="data-sort-ui-1" onClick={() => onChangeSortOrder(option.value)} >

                    <a  title={option.title} className="a-link cursor-pointer" dangerouslySetInnerHTML={{ __html: option.label }}></a>
                  </span>
                  :
                  ''
              )
            }

            <span className="dropdowns">

              <a  className={`sort-options cursor-pointer ${sortOptions?.length > 1 ? 'down-arrow-ui1' : ''}`}>
                {" "}
                Sort by: <span className="text_h1"> {selectedSortOption.label} </span>{" "}
              </a>
              {
                sortOptions?.length > 1 ?
                  <ul className="dropdown-contents">
                    {
                      sortOptions.map((option: any, index: number) =>
                        selectedSortOption.value == option.value ?
                          ''
                          :
                          <li key={`SortOption${index}`} onClick={() => onClickSortOption(option)} >
                            {" "}
                            <a className="a-link cursor-pointer">
                              {" "}
                              {option.label}{" "}
                            </a>{" "}
                          </li>
                      )
                    }
                  </ul>
                  : ''}

            </span>
          </li>
          :
          <SortListShimmer />
      }
    </>
  );
};

export default Sortist;
